import { Fragment } from "react";

import { GroupHeader } from "./GroupHeader";
import { MobileCard } from "./MobileCard";
import { MobileList as MobileListWrapper } from "./styles";
import { MobileListProps } from "./types";

export const MobileList: React.FC<MobileListProps> = ({
  groups,
  accountIdsByName,
  onEdit,
  onDuplicate,
  onDelete,
}) => (
  <MobileListWrapper>
    {groups.map((group) => (
      <Fragment key={group.dateKey}>
        <GroupHeader group={group} variant="mobile" />
        {group.transactions.map((transaction) => (
          <MobileCard
            key={transaction.id}
            transaction={transaction}
            accountIdsByName={accountIdsByName}
            onEdit={onEdit}
            onDuplicate={onDuplicate}
            onDelete={onDelete}
          />
        ))}
      </Fragment>
    ))}
  </MobileListWrapper>
);
